import { combineReducers } from "@reduxjs/toolkit";
import { classReducer } from "data/class";
import { errorReducer } from "data/error";
import { localFlagsReducer } from "data/localFlags";

import { taskReducer } from "@/data/task";
import { markReducer } from "@/features/marking";
import { moderateReducer } from "@/features/moderation";
import { questionFormValidationReducer } from "@/features/multi-format/question-form-validation";
import { taskLayoutReducer } from "@/features/multi-format/task-layout";
import { questionBanksReducer } from "@/features/question-bank-file-import/data";
import { questionImportReducer } from "@/features/question-library-file-import/data";

import { templatesReducer } from "./templates";

export const rootReducer = combineReducers({
  error: errorReducer,
  task: taskReducer,
  templates: templatesReducer,
  class: classReducer,
  localFlags: localFlagsReducer,
  taskLayout: taskLayoutReducer,
  questionFormValidation: questionFormValidationReducer,
  questionBanks: questionBanksReducer,
  questionImport: questionImportReducer,
  mark: markReducer,
  moderate: moderateReducer,
});
